import { deviceManager } from "../../device/device_manager"

export const handleDeviceState = async () => {
  const ret = await  deviceManager.deviceDriver.getDeviceState()
  return ret
}
